export default __webpack_public_path__ + "static/Butterfly-d544de058ec8cb9316a00e53d818882b.webp";